import React, {FC} from 'react'
import s from './index.module.scss'
import Logo from '../../../../img/brand-new-logo.svg'
import LogoWhite from '../../../../img/brand-new-white-logo.svg'
import ExternalLink from '../../../common/externalLink'
import {GiftContent} from '../index'
import ArrowsIcon from './logo.react.svg'
import ScrollIcon from './arrow.react.svg'
//import ScrollIconWhite from './arrow-white.react.svg'
import cn from "classnames";

type Props = {
  renderForm: () => any
  content: GiftContent
}

const Register: FC<Props> = ({content, renderForm}) => {
  const skipHero = () => {
    window.scrollTo(0, window.innerHeight)
  }
  const isNarrowContent = content?.gift_code === "BOCAWEST23"

  const invertedColors = content?.data?.invertedColors === 'true'
  const largeBackground = content?.data?.largeBackground === 'true'
  const transformLink = (val: string): string => {
    const params = new URLSearchParams(window.location.search);
    params.delete('code');
    const queryString = params.toString();
    return queryString ? `${val}?${queryString}` : val;
  };
  return (
    <div id='form' className={cn(s.root, invertedColors && s.grayBg)}>
      <div className={cn(s.content, largeBackground && s.large)} style={largeBackground ? {backgroundImage: `url(${content?.data?.background || 'https://website-cdn.flyxo.com/data/webapi/image_9d84b0c6d2.jpg'})`} : {}}>
        {content ? (
          <div className={cn(s.image, largeBackground && s.large)} style={{backgroundImage: `url(${(largeBackground ? content?.data?.mobileBackground : content?.data?.background) || 'https://website-cdn.flyxo.com/data/webapi/image_9d84b0c6d2.jpg'})`}}>
            <div className={cn(s.topContent, largeBackground && s.large)}>
              <ExternalLink to={transformLink("https://flyxo.com")}>
                <img className={s.logo} src={invertedColors ? LogoWhite : Logo} alt="XO logo"/>
              </ExternalLink>
              {content?.title.split(' to ').length > 1 ? (
                <h1 className={invertedColors ? s.whiteTitle : s.title}>
                  {content?.title.split(' to ')[0]}<img alt='' aria-hidden={true} className={s.icon} src={ArrowsIcon} /><br/>
                  {content?.title.split(' to ')[1]}
                </h1>
              ) : <h1 dangerouslySetInnerHTML={{__html: content?.title}} className={invertedColors ? s.whiteTitle : s.title} />}
              {largeBackground ? (
                <div className={invertedColors ? isNarrowContent ? s.narrowWhiteSubtitle : s.whiteSubtitle : s.subTitle } dangerouslySetInnerHTML={{__html: content?.sub_title}} />
              ) : (
                <div className={invertedColors ? isNarrowContent ? s.narrowWhiteSubtitle : s.whiteSubtitle : s.subTitle }>{content?.sub_title}</div>
              )}

              {!!content?.data?.benefits ? (
                <button type='button' onClick={skipHero} className={s.scrollButton}>
                  <img alt='' aria-hidden={true} className={s.scrollIcon} src={ScrollIcon} />
                </button>
              ) : null}
            </div>
          </div>
        ) : null}
        <div id={'form-anchor'} className={cn(s.formContent, largeBackground && s.large)}>
          {renderForm()}
        </div>
      </div>
    </ div>
  )
}

export default Register
